<template>
  <v-container>
    <v-card class="mx-auto" max-width="400">
      <v-img
        class="white--text align-end"
        height="300px"
        :src="require('@/assets/anuncios/testamento.jpeg')"
      >
        <v-card-title class="black" style="opacity:0.5;">Septiembre: Mes del testamento</v-card-title>
      </v-img>

      <v-card-text
        class="text--primary"
      >Lo más importante que podemos heredar a nuestras familias es tranquilidad para cuando ya no estemos; el objetivo principal de esta campaña es fortalecer los lazos familiares y dar certeza a las familias y a todas las y los mexicanos sobre su patrimonio.</v-card-text>

      <v-card-actions>
        <v-btn color="accent" text @click="openDialog('TestamentoKnow')">Lo que debes saber</v-btn>

        <v-btn color="accent" text @click="openDialog('TestamentoProc')">Procedimiento</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-card-text v-if="dialogName">
          <component :is="dialogName" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as components from "./anuncios";
export default {
  components,
  data() {
    return {
      dialog: false,
      dialogName: null,
    };
  },
  methods: {
    openDialog(name) {
      this.dialog = true;
      this.dialogName = name;
    },
  },
};
</script>